import { TOGGLE } from './mutation-types';

/* eslint-disable no-param-reassign */
export default {
  [TOGGLE](state, payload) {
    state.contactUsStatus = payload;
  },
};
